import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/rem';
  @import 'src/common/styling/_mixins-scss/screen-size';

  .PeriodicalReportTable {
    .ReactDataTable__wrapper {
      .ReactDataTable {
        tr {
          grid-template-columns:
            minmax(120px, 1fr) /* IB account */
            minmax(150px, 1.5fr) /* Report type */
            minmax(120px, 1fr) /* Frequency */
            minmax(150px, 1.5fr) /* Option */
            minmax(70px, 0.7fr); /* Actions */
        }

        .ReactDataTable__tbody-cell {
          display: flex;
          align-items: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          span {
            font-size: rem(14px);
          }
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;
      display: flex;

      span {
        text-align: center;
        padding: 5px 0;

        &:nth-child(1) {
          flex: 2; /* IB account */
        }

        &:nth-child(2) {
          flex: 3; /* Report type */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__preview-main {
        display: flex;
        align-items: center;
        gap: 8px;

        .ResponsiveTable__row-item {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:nth-child(1) {
            flex: 2; /* IB account */
          }

          &:nth-child(2) {
            flex: 3; /* Report type */
          }
        }
      }

      .ResponsiveTable__preview-description {
        .ResponsiveTable__row-item {
          justify-content: flex-start;
          padding-left: 10%;
        }
      }

      .ResponsiveTable__details-item {
        padding-left: 15%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`;

export { staticStyles };
